import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = { class: "ion-margin-top ion-margin-start" }
const _hoisted_3 = { class: "ion-margin-bottom ion-margin-start" }
const _hoisted_4 = {
  key: 1,
  class: "ion-margin-top"
}
const _hoisted_5 = { class: "ion-padding-top" }
const _hoisted_6 = { class: "ion-padding-top" }
const _hoisted_7 = { class: "ion-margin-start" }
const _hoisted_8 = { class: "ion-margin-start ion-padding-top" }

import {
  AlertInformation,
  CustomElement,
  EditableState,
  Grade,
  GradeProps,
  ProjectClassStudent,
  User,
  LearningSession,
  LearningSessionStatus,
  Course,
  AdminProjectClass,
  TmpList,
  SubscriptionsManagerMode,
  SubscriptionsManager,
  Outcome,
  SuccessCodes,
  ErrorCodes,
  EnrollmentAvailability,
  GeneralTableCardElements,
  OrderedCardsList,
  SingleGradesParameters,
  MultipleGradesParameters,
  StudentGrade,
} from "@/types";
import {
  executeLink,
  getAviableLanguages,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getIcon,
  removeTableIndexedElement,
  setupError,
  toDateString,
} from "@/utils";
import { IonModal, IonAlert, AlertButton, IonButton } from "@ionic/vue";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

type AvailableModal =
  | "grades"
  | "multiple_grades"
  | "course_details"
  | "empty_descriptions"
  | "edit_grade"
  | "remove_grade"
  | "student_mover"
  | "move_student"
  | "remove_student"
  | "confirmation"
  | "success"
  | "error";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectClass',
  async setup(__props) {

let __temp: any, __restore: any

const setupModalAndOpen = (window?: AvailableModal, message?: string) => {
  //<!-- ! (3): è possibile dare voti in una sessione futura (forse problema su utilizzo sessioni rimaneggiate)
  const actual_window: AvailableModal = window ?? store.state.event.event;
  const actual_message: string = message ?? store.state.event.data?.message;

  let tmp_grade: Grade, new_grade: Grade, tmp_description: string;

  switch (actual_window) {
    case "grades":
      grades_title = store.state.event.data.title;
      grades_parameters = {
        ...store.state.event.data.parameters,
        associated_teacher: associated_teacher,
        final_grade_index:
          final_grades_indexes[store.state.event.data.parameters.student_id],
      };
      student_grades = grades[grades_parameters.student_id];
      grades_open.value = true;
      break;
    case "remove_grade":
    case "edit_grade":
      findGrade();
      if (grade_index.student_id != -1 && grade_index.index != -1) {
        tmp_grade = grades[grade_index.student_id][grade_index.index];
        alert_information.title = "";
        alert_information.message = getCurrentElement(
          (actual_window == "edit_grade" ? "edit" : "remove") +
            "_grade_confirmation"
        );
        /*+ (grade_index != undefined
          ? "<br />" + getCurrentElement("description") + ": " + tmp_grade[`${language}_description`] + "<br />"
          + getCurrentElement("grade") + ": " + tmp_grade.grade + " [" + getCurrentElement("final") + "]"
          : "");*/ //<!-- TODO (5): abilita innerHTMLTemplatesEnabled nelle config per farlo funzionare
        if (actual_window == "edit_grade") {
          new_grade = store.state.event.data.new_grade;
          edits_to_send = {
            id: false,
            italian_description: false,
            english_description: false,
            publication: false,
            grade: false,
            final: false,
          };
          //alert_information.message += "\n" + getCurrentElement("with_following_edits");
          for (const tmp_language of languages) {
            tmp_description = `${tmp_language}_description`;
            if (tmp_grade[tmp_description] != new_grade[tmp_description]) {
              edits_to_send[tmp_description] = true;
              //alert_information.message += "\n" + getCurrentElement(`${language}_description`) + ": " + new_grade[`${language}_description`];
            }
          }
          if (
            tmp_grade.publication.getTime() != new_grade.publication.getTime()
          ) {
            edits_to_send.publication_date = true;
            //alert_information.message += "\n" + getCurrentElement("date") + ": " + toDateString(new_grade.publication);
          }
          if (tmp_grade.grade != new_grade.grade) {
            edits_to_send.grade = true;
            //alert_information.message += "\n" + getCurrentElement("grade") + ": " + new_grade.grade;
          }
        }
        alert_information.buttons = [
          handled_buttons[0],
          getCurrentElement("no"),
        ];
        alert_open.value = true;
      } else {
        setupError();
        alert_open.value = true;
      }
      break;
    case "remove_student":
      findStudent();
      if (student_index.student_list != -1 && student_index.table != -1) {
        alert_information.title = "";
        alert_information.message = getCurrentElement(
          "remove_student_confirmation"
        );
        alert_information.buttons = [
          handled_buttons[0],
          getCurrentElement("no"),
        ];
        alert_open.value = true;
      } else {
        setupError();
        alert_open.value = true;
      }
      break;
    case "student_mover":
      student_mover_data = {
        title: store.state.event.data.title,
        parameters: store.state.event.data.parameters,
      };
      student_mover_open.value = true;
      break;
    case "move_student":
      alert_information.title = "";
      alert_information.message = getCurrentElement(
        "move_student_confirmation"
      );
      alert_information.buttons = [handled_buttons[0], getCurrentElement("no")];
      alert_open.value = true;
      break;
    case "empty_descriptions":
      alert_information.title = getCurrentElement("error");
      alert_information.message = getCurrentElement("empty_descriptions");
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
    case "course_details":
      description_title = store.state.event.data.title;
      description_course_id = store.state.event.data.course_id;
      description_open.value = true;
      break;
    case "confirmation":
      alert_information.title = getCurrentElement("project_class_confirmation");
      alert_information.message = getCurrentElement(
        "project_class_confirmation_question"
      );
      alert_information.buttons = [handled_buttons[0], getCurrentElement("no")];
      alert_open.value = true;
      break;
    case "multiple_grades":
      multiple_grades_parameters.section = selected_section.value;
      multiple_grades_open.value = true;
      break;
    case "success":
      alert_information.title = "";
      alert_information.message =
        message ?? getCurrentElement(getCurrentElement("successful_operation"));
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
    case "error":
      setupError(actual_message);
      alert_open.value = true;
      break;
  }
};
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "grades":
      grades_open.value = false;
      break;
    case "multiple_grades":
      multiple_grades_open.value = false;
      break;
    case "course_details":
      description_open.value = false;
      break;
    case "student_mover":
      student_mover_open.value = false;
      break;
    case "empty_descriptions":
    case "remove_grade":
    case "edit_grade":
    case "move_student":
    case "confirmation":
    case "remove_student":
    case "success":
    case "error":
      alert_open.value = false;
      break;
  }
};
const add_grade = async () => {
  const data = store.state.event.data;

  executeLink(
    "/v1/students/" +
      data.student_id +
      "/grades?course_id=" +
      data.course_id +
      "&session_id=" +
      data.session_id,
    (response) => {
      const tmp_grade = new Grade({
        id: response.data.value.id,
        publication: response.data.value.publication,
        italian_description: data.italian_description,
        english_description: data.english_description,
        grade: data.grade,
        final: data.final ? 1 : 0,
      });

      grades[data.student_id].push(tmp_grade);
      updateFinalRefs(data.student_id, tmp_grade);
    },
    () => setupModalAndOpen("error"),
    "post",
    {
      ita_description: data.italian_description,
      eng_description: data.english_description,
      publication_date: data.publication_date,
      grade: data.grade,
      final: data.final,
    }
  );
};

const add_grades = () => {
  const data = store.state.event.data;

  executeLink(
    "/v1/grades?course_id=" + data.course_id + "&session_id=" + data.session_id,
    (response) => {
      let tmp_grade: Grade;

      for (const grade_ref of response.data.grades_id) {
        tmp_grade = new Grade({
          id: grade_ref.id,
          publication: response.data.publication,
          italian_description: data.italian_description,
          english_description: data.english_description,
          grade: data.grades_list.find(
            (a: StudentGrade<number>) => a.student_id == grade_ref.student_id
          ).grade_value,
          final: data.final ? 1 : 0,
        });

        grades[grade_ref.student_id].push(tmp_grade);
        updateFinalRefs(grade_ref.student_id, tmp_grade);
      }

      if (
        response.data.students_with_errors != undefined &&
        response.data.students_with_errors.length > 0
      ) {
        setupModalAndOpen("error", getCurrentElement("grades_with_errors"));
      } else if (response.data.duplicate_entry == true) {
        setupModalAndOpen(
          "error",
          getCurrentElement("already_existing_grades")
        );
      } else if (response.data.wrong_entry == true) {
        setupModalAndOpen("error");
      }
    },
    () => setupModalAndOpen("error"),
    "post",
    {
      ita_description: data.italian_description,
      eng_description: data.english_description,
      publication_date: data.publication_date,
      grades_list: data.grades_list,
      final: data.final,
    }
  );
};

const updateStudents = async () => {
  students =
    selected_section.value != ""
      ? await executeLink(
          "/v1/project_classes/" +
            course_id +
            "/" +
            session_id +
            "/components?section=" +
            selected_section.value +
            (user.type == "teacher" ? "&teacher_id=" + user.id : ""),
          (response) => {
            const tmp_students: ProjectClassStudent[] = [];

            associated_teacher = response.data.data.associated_teacher;
            multiple_grades_parameters.associated_teacher = associated_teacher;
            column_sizes =
              //(user.type == "teacher" && associated_teacher == true) ||
              user.type == "admin" &&
              (project_class?.final_confirmation != undefined ||
                learning_session_status == LearningSessionStatus.CURRENT ||
                learning_session_status == LearningSessionStatus.COMPLETED)
                ? ["1", "6", "3", "2"]
                : ["1", "4", "2", "1.5", "1.5", "2"];
            if (first_row.length != column_sizes.length) {
              if (project_class?.final_confirmation == undefined) {
                first_row.push(
                  {
                    id: "move",
                    type: "string",
                    content: getCurrentElement("move"),
                  },
                  {
                    id: "remove",
                    type: "string",
                    content: getCurrentElement("remove"),
                  }
                );
              } else {
                first_row.pop();
                first_row.pop();
              }
            }
            response.data.data.components.map((a: any) => {
              tmp_students.push(
                new ProjectClassStudent(a, course_id, session_id)
              );
            });

            return tmp_students;
          },
          () => []
        )
      : [];

  table_data.cards[""] = [];
  for (const student_index in students) {
    //<!-- TODO (5): controllare se ci sono più professori e fare richieste voti solamente sul pulsante (evitare problema di professore che aggiunge mentre altro è nella pagina)
    tmp_student = students[student_index];
    if (user.type == "teacher") {
      grades[tmp_student.id] = await executeLink(
        "/v1/students/" +
          tmp_student.id +
          "/grades?course_id=" +
          course_id +
          "&session_id=" +
          session_id +
          "&teacher_id=" +
          user.id,
        (response: any) =>
          response.data.data.map((a: GradeProps, i: number) => {
            const tmp_grade = new Grade(a);
            if (tmp_grade.final) {
              final_grades_indexes[tmp_student.id] = i;
            }
            return tmp_grade;
          }),
        () => []
      );
    }

    table_data.cards[""].push(
      tmp_student.toTableCard(
        user.type == "teacher" ? user.id : undefined,
        user.type == "teacher",
        user.type == "teacher"
          ? grades[tmp_student.id][final_grades_indexes[tmp_student.id]]
          : undefined,
        learning_session_status != LearningSessionStatus.CURRENT &&
          learning_session_status != LearningSessionStatus.COMPLETED
          ? project_class?.final_confirmation
          : new Date(),
        undefined,
        parseInt(student_index) + 1
      )
    );
  }
};

const updatePendingStudents = async () => {
  pending_students = await executeLink(
    "/v1/project_classes/" + course_id + "/" + session_id + "/components",
    (response) =>
      response.data.data.components.map(
        (s: any) => new ProjectClassStudent(s, course_id, session_id)
      ),
    () => []
  );

  pending_table_data.cards[""] = [];
  for (const student_index in pending_students) {
    //<!-- TODO (5): controllare se ci sono più professori e fare richieste voti solamente sul pulsante (evitare problema di professore che aggiunge mentre altro è nella pagina)
    tmp_student = pending_students[student_index];
    pending_table_data.cards[""].push(
      tmp_student.toTableCard(
        undefined,
        false,
        undefined,
        learning_session_status != LearningSessionStatus.CURRENT &&
          learning_session_status != LearningSessionStatus.COMPLETED
          ? project_class?.final_confirmation
          : new Date(),
        undefined,
        parseInt(student_index) + 1
      )
    );
  }
};
const manageEvent = () => {
  switch (store.state.event.event) {
    case "add_grade":
      add_grade();
      break;
    case "add_grades":
      add_grades();
      break;
    default:
      setupModalAndOpen();
      break;
  }
};
const yes_handler = async () => {
  let body: {
      [key in keyof GradeProps]?: any;
    },
    edits_props: GradeProps,
    count = 0,
    something_to_edit = false,
    edit_keys: string[],
    tmp_grade: Grade,
    outcome: Outcome,
    index: number;

  const table = is_pending ? pending_table_data : table_data;
  const list = is_pending ? pending_students : students;

  switch (store.state.event.event) {
    case "confirmation":
      if (course != undefined && project_class != undefined) {
        if (
          table_data.cards[""].length < course.min_students ||
          table_data.cards[""].length > course.max_students
        ) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("students_number_error")
              ),
            300
          );
        } else if (learning_session_status != LearningSessionStatus.UPCOMING) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("learning_session_not_upcoming")
              ),
            300
          );
        } else if (project_class.final_confirmation != undefined) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("project_class_already_confirmed")
              ),
            300
          );
        } else {
          await executeLink(
            "/v1/project_classes/" +
              course_id +
              "/" +
              session_id +
              "/final_confirmation",
            (response) => {
              (project_class as AdminProjectClass).final_confirmation =
                response.data.confirmation_date != undefined
                  ? new Date(response.data.confirmation_date)
                  : new Date();
              setTimeout(
                () =>
                  setupModalAndOpen(
                    "success",
                    getCurrentElement("project_class_successful_confirmation")
                  ),
                300
              );
              students_update.value++;
            },
            () => setTimeout(() => setupModalAndOpen("error"), 300),
            "put"
          );
        }
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
      break;
    case "remove_grade":
      if (learning_session != undefined) {
        tmp_grade = grades[grade_index.student_id][grade_index.index];
        if (associated_teacher) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("no_grade_remotion_permissions")
              ),
            300
          );
        } else if (
          tmp_grade.getEditableStatus(
            final_grades_indexes[grade_index.student_id] != undefined
              ? grades[grade_index.student_id][
                  final_grades_indexes[grade_index.student_id]
                ].publication
              : undefined
          ) != EditableState.EDITABLE
        ) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("cannot_remove_grade")
              ),
            300
          );
        } else {
          await executeLink(
            "/v1/grades/" + store.state.event.data.id,
            () => {
              updateFinalRefs("" + grade_index.student_id, tmp_grade, true);
              grades[grade_index.student_id].splice(grade_index.index, 1);
              setTimeout(
                () =>
                  setupModalAndOpen(
                    "success",
                    getCurrentElement("successful_grade_remotion")
                  ),
                300
              );
              store.state.triggers.grades++;
            },
            () => setTimeout(() => setupModalAndOpen("error"), 300),
            "delete"
          );
        }
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
      break;
    case "edit_grade":
      if (learning_session != undefined) {
        edits_props = store.state.event.data.new_grade.toProps();
        body = {
          ita_description: edits_to_send.italian_description
            ? edits_props.italian_description
            : undefined,
          eng_description: edits_to_send.english_description
            ? edits_props.english_description
            : undefined,
          grade: edits_to_send.grade ? edits_props.grade : undefined,
          publication_date: edits_to_send.publication_date
            ? edits_props.publication
            : undefined,
        };
        //<!-- TODO (6): modificare quando ci sarà coerenza nei parametri
        /*for (const key in edits_to_send) {
          if (edits_to_send[key]) {
            body[key] = edits_props[key];
          }
        }*/
        edit_keys = Object.keys(body);

        while (
          !(something_to_edit = body[edit_keys[count]] != undefined) &&
          ++count < edit_keys.length
        );
        if (associated_teacher) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("no_grade_edit_permissions")
              ),
            300
          );
        } else if (!something_to_edit) {
          setTimeout(
            () => setupModalAndOpen("error", getCurrentElement("no_edits")),
            300
          );
        } else if (
          grades[grade_index.student_id][grade_index.index].getEditableStatus(
            final_grades_indexes[grade_index.student_id] != undefined
              ? grades[grade_index.student_id][
                  final_grades_indexes[grade_index.student_id]
                ].publication
              : undefined
          ) != EditableState.EDITABLE
        ) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("cannot_edit_grade")
              ),
            300
          );
        } else {
          await executeLink(
            "/v1/grades/" + store.state.event.data.id,
            () => {
              tmp_grade = Object.assign(
                grades[grade_index.student_id][grade_index.index],
                store.state.event.data.new_grade
              );
              setTimeout(
                () =>
                  setupModalAndOpen(
                    "success",
                    getCurrentElement("successful_edit")
                  ),
                300
              );
              updateFinalRefs(
                "" + grade_index.student_id,
                store.state.event.data.new_grade,
                false,
                false
              );
              store.state.triggers.grades++;
              store.state.triggers.edit_grades++;
            },
            () => setTimeout(() => setupModalAndOpen("error"), 300),
            "put",
            body
          );
        }
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
      break;
    case "remove_student":
      if (course != undefined && project_class != undefined) {
        if (project_class.final_confirmation != undefined) {
          setTimeout(
            () =>
              setupModalAndOpen(
                "error",
                getCurrentElement("class_already_confirmed")
              ),
            300
          );
        } else {
          await executeLink(
            "/v1/students/" +
              store.state.event.data.parameters.student_id +
              "/remove_class?course_id=" +
              course.id +
              "&session_id=" +
              project_class.learning_session.id,
            () => {
              table.cards[""].splice(student_index.table, 1);
              list.splice(student_index.student_list, 1);
              fix_indexes();
              setTimeout(
                () =>
                  setupModalAndOpen(
                    "success",
                    getCurrentElement("successful_student_remotion")
                  ),
                300
              );
              students_trigger.value++;
            },
            (e) => {
              outcome = {
                code: ErrorCodes.GENERIC,
                subcode: 0,
                message: getCurrentElement("generic_error"),
              };
              if (e.response != undefined) {
                if (e.response.status == 400) {
                  if (
                    e.response.data.description == backend_errors.minStudents
                  ) {
                    outcome.subcode = 1;
                    outcome.message = getCurrentElement("min_students_error");
                  }
                }
              }
              setTimeout(
                () => setupModalAndOpen("error", outcome.message),
                300
              );
            },
            "delete"
          );
        }
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
      break;
    case "move_student":
      if (project_class != undefined) {
        outcome = await moveStudent(subscriptions_manager, project_class);
        closeModal("move_student");
        switch (outcome.code) {
          case SuccessCodes.GENERIC:
            index = removeTableIndexedElement(
              table,
              store.state.event.data.student_id
            );
            if (list[index].id == store.state.event.data.student_id) {
              list.splice(index, 1);
            } else {
              list.splice(
                list.findIndex(
                  (a) => a.id == store.state.event.data.student_id
                ),
                1
              );
            }
            students_trigger.value++;
            closeModal("student_mover");
            setTimeout(
              () => setupModalAndOpen("success", outcome.message),
              500
            );
            break;
          case ErrorCodes.GENERIC:
          case ErrorCodes.BAD_REQUEST:
            setTimeout(() => setupModalAndOpen("error", outcome.message), 300);
            break;
        }
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
      break;
  }
};
const findGrade = () => {
  let count = 0;

  while (
    (grade_index.index = grades[
      (grade_index.student_id = students[count].id)
    ].findIndex((a) => a.id == store.state.event.data.id)) == -1 &&
    ++count < Object.keys(grades).length
  );
};
const findStudent = () => {
  const table = is_pending
    ? pending_table_data.cards[""]
    : table_data.cards[""];
  const list = is_pending ? pending_students : students;
  const tmp_student_id = store.state.event.data.parameters.student_id;

  student_index.table = table.findIndex((a) => a.id == tmp_student_id);
  student_index.student_list = list.findIndex((a) => a.id == tmp_student_id);
};
const updateFinalRefs = (
  student_id: string,
  grade: Grade,
  deleted_grade = false,
  update_indexes = true
) => {
  let student_pos: number, final_grade_pos: number;

  if (grade.final == true) {
    student_pos = table_data.cards[""].findIndex((a) => a.id == student_id);
    if (update_indexes) {
      final_grades_indexes[student_id] = grades[student_id].length - 1;
    }
    for (const final_grade_id of (table_data.cards[""][student_pos]
      .linked_elements ?? {
      final_grade: [],
    })["final_grade"]) {
      final_grade_pos = table_data.cards[""][student_pos].content.findIndex(
        (a) => a.id == final_grade_id
      );
      if (deleted_grade) {
        table_data.cards[""][student_pos].content[final_grade_pos].content = (
          table_data.cards[""][student_pos].content[final_grade_pos]
            .content as string
        ).replace(/\d+/g, "-");
        grades_parameters.final_grade_index = undefined;
        delete final_grades_indexes[student_id];
        store.state.triggers.grades++;
      } else {
        table_data.cards[""][student_pos].content[final_grade_pos].content = (
          table_data.cards[""][student_pos].content[final_grade_pos]
            .content as string
        ).replace(/(\d+|-)/g, "" + grade.grade);
      }
    }
    students_trigger.value++;
  }
};
const moveStudent = async (
  subscriptions_manager: SubscriptionsManager,
  origin_project_class: AdminProjectClass
): Promise<Outcome> => {
  const outcome: Outcome = {
    code: SuccessCodes.GENERIC,
  };

  let enrollment_availability: EnrollmentAvailability;

  if (subscriptions_manager.mode != SubscriptionsManagerMode.MOVE) {
    outcome.code = ErrorCodes.BAD_REQUEST;
  } else if (
    origin_project_class.final_confirmation != undefined &&
    store.state.event.data.to.final_confirmation != undefined
  ) {
    outcome.code = ErrorCodes.GENERIC;
    outcome.subcode = 0;
    outcome.message = getCurrentElement("class_already_confirmed");
  } else {
    enrollment_availability = subscriptions_manager.checkEnrollmentAvailability(
      store.state.event.data.to.learning_context_id,
      store.state.event.data.to.learning_area_id,
      store.state.event.data.to.course_id,
      store.state.event.data.from.course_id
    );
    if (enrollment_availability.course != undefined) {
      if (!enrollment_availability.available_courses) {
        outcome.code = ErrorCodes.GENERIC;
        outcome.subcode = 3;
        outcome.message = getCurrentElement("cannot_move_for_group");
      } else if (!enrollment_availability.available_credits) {
        outcome.code = ErrorCodes.GENERIC;
        outcome.subcode = 4;
        outcome.message = getCurrentElement("cannot_move_for_credits");
      } else {
        outcome.message = getCurrentElement("student_moved");
        await executeLink(
          "/v1/students/" + store.state.event.data.student_id + "/move_class",
          () => {
            outcome.message = getCurrentElement("student_moved");
          },
          (e) => {
            outcome.code = ErrorCodes.GENERIC;
            if (e.response != undefined) {
              if (e.response.status == 400) {
                if (e.response.data.description == backend_errors.minStudents) {
                  // <!-- TODO (5): aggiungere codici errore in backend
                  outcome.subcode = 5;
                  outcome.message = getCurrentElement("min_students_error");
                } else if (
                  e.response.data.description == backend_errors.maxStudents
                ) {
                  outcome.subcode = 6;
                  outcome.message = getCurrentElement("max_students_error");
                } else {
                  outcome.subcode = 2;
                }
              }
            } else {
              outcome.subcode = 2;
            }
          },
          "put",
          {
            from: {
              course_id: store.state.event.data.from.course_id,
              session_id: store.state.event.data.from.session_id,
            },
            to: {
              course_id: store.state.event.data.to.course_id,
              session_id: store.state.event.data.to.session_id,
              section: store.state.event.data.to.section,
            },
          }
        );
      }
    } else {
      outcome.code = ErrorCodes.GENERIC;
      outcome.subcode = 1;
    }
  }

  return outcome;
};
const fix_indexes = () => {
  const table = is_pending
    ? pending_table_data.cards[""]
    : table_data.cards[""];

  for (let i = 0; i < table.length; i++) {
    for (const index_id of (
      table[i].linked_elements ?? {
        index: [],
      }
    ).index) {
      table[i].content[
        table[i].content.findIndex((a) => a.id == index_id)
      ].content = (
        table[i].content[table[i].content.findIndex((a) => a.id == index_id)]
          .content as string
      ).replace(/\d+/g, "" + (i + 1));
    }
  }
};

const areAllFinals = () => {
  return Object.keys(final_grades_indexes).length == Object.keys(grades).length;
};

const setUpPendingAndOpen = (value = false) => {
  is_pending = value;
  setupModalAndOpen();
};

const showPending = computed(
  () =>
    user.type == "admin" &&
    ((learning_session_status == LearningSessionStatus.FUTURE &&
      learning_session?.open_day != undefined &&
      learning_session.open_day <= new Date()) ||
      learning_session_status == LearningSessionStatus.UPCOMING)
);

const store = useStore();
const $router = useRouter();
const user = User.getLoggedUser() as User;
const sections_use: boolean = store.state.sections_use;
const languages = getAviableLanguages();
const language = getCurrentLanguage();
const $route = useRoute();
const alert_information: AlertInformation = store.state.alert_information;

const first_row: CustomElement[] = [
  {
    id: "index",
    type: "string",
    content: "",
  },
  {
    id: "student",
    type: "string",
    content: getCurrentElement("student"),
  },
  {
    id: "class",
    type: "string",
    content: getCurrentElement("class"),
  },
  {
    id: "learning_context",
    type: "string",
    content: getCurrentElement("learning_context"),
  },
];
const grades_open = ref(false);
const multiple_grades_open = ref(false);
const description_open = ref(false);
const student_mover_open = ref(false);
const course_id = $route.params.course as string;
const session_id = $route.params.session as string;
const students_trigger = ref(0);
const students_update = ref(0);
const grades: {
  [student_id: string]: Grade[];
} = {};
const final_grades_indexes: {
  [student_id: string]: number;
} = {};
const alert_open = ref(false);
const sections: { id: string }[] = [];
const tmp_sections: Set<string> = new Set();
const backend_errors = {
  minStudents:
    "The class will not have anymore the min number of students required. Please, try again.",
  maxStudents:
    "Too many students. You can not move the student to the destination class.",
};
const button_css = Object.assign(
  JSON.parse(JSON.stringify(store.state.button_css)),
  {
    classes: {
      button: {
        radius: true,
        "ion-margin-start": {
          general: true,
          sm: false,
        },
      },
    },
  }
);
const buttons: CustomElement[] = [
  {
    id: "announcements",
    type: "string_icon",
    linkType: "request",
    content: {
      url: "/announcements/" + course_id + "/" + session_id, //<!-- ? vedere se anche admin può vedere e/o mandare messaggi
      method: "get",
      icon: getIcon("mail"),
      text: getCurrentElement("announcements"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "course_details",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "course_details",
      data: {
        title: "", //<!-- TODO (4): mettere titolo quando ce l'avrà anche la pagina
        course_id: parseInt(course_id),
      },
      icon: getIcon("information_circle"),
      text: getCurrentElement("course_details"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "register_grades_series",
    type: "string_icon",
    linkType: "event",
    content: {
      text: getCurrentElement("register_grades_series"),
      icon: getIcon("add"),
      event: "multiple_grades",
      whole_link: true,
    },
    ...button_css,
  },
];
if (buttons[2].classes == undefined) {
  buttons[2].classes = {};
}
buttons[2].classes.label = {
  "ion-text-wrap": true,
};
const selected_section = ref("");
const handled_buttons: AlertButton[] = [
  {
    text: getCurrentElement("yes"),
    handler: yes_handler,
  },
];
const grade_index = {
  student_id: -1,
  index: -1,
};
const student_index = {
  student_list: -1,
  table: -1,
};
const learning_sessions: LearningSession[] = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_sessions?year_of=" + session_id,
  (response) => response.data.data.map((a: any) => new LearningSession(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
const learning_session_position = learning_sessions.findIndex(
  (a) => a.id == parseInt(session_id)
);
const learning_session =
  learning_session_position != -1
    ? learning_sessions[learning_session_position]
    : undefined;
const learning_session_status =
  learning_session != undefined ? learning_session.getStatus() : undefined;
const subscriptions_manager = new SubscriptionsManager(
  SubscriptionsManagerMode.MOVE
); // Not ready, loadParameters will be run with project-class-selector
const table_data: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const pending_table_data: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const multiple_grades_parameters: MultipleGradesParameters = {
  course_id: parseInt(course_id),
  session_id: parseInt(session_id),
  teacher_id: user.id,
  section: selected_section.value,
};
const course: Course = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/courses/" + course_id,
  (response) => new Course(response.data.data),
  () => undefined
))),
  __temp = await __temp,
  __restore(),
  __temp
);

let grades_title: string;
let grades_parameters: SingleGradesParameters;
let student_grades: Grade[] | undefined;
let description_title: string;
let description_course_id: number;
let associated_teacher: boolean | undefined;
let project_class: AdminProjectClass | undefined;
let students: ProjectClassStudent[] = [];
let pending_students: ProjectClassStudent[] = [];
let tmp_student: ProjectClassStudent;
let edits_to_send: {
  [key in keyof GradeProps]: boolean;
};
let column_sizes: string[] = [];
let student_mover_data: TmpList;
let is_pending = false;

if (user.type == "teacher") {
  first_row.push(
    {
      id: "grades",
      type: "string",
      content: getCurrentElement("grades"),
    },
    {
      id: "final_grade",
      type: "string",
      content: getCurrentElement("final_grade"),
    }
  );
  ;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v2/teachers/" +
      user.id +
      "/my_project_classes?session_id=" +
      session_id +
      "&course_id=" +
      course_id,
    (response) =>
      response.data.data.map((a: any) => tmp_sections.add(a.section))
  ))),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v2/teachers/" +
      user.id +
      "/associated_project_classes?session_id=" +
      session_id +
      "&course_id=" +
      course_id,
    (response) =>
      response.data.data.map((a: any) => tmp_sections.add(a.section))
  ))),
  await __temp,
  __restore()
);
  for (const section of tmp_sections) {
    sections.push({
      id: section,
    });
  }
} else {
  (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v1/project_classes/" + course_id + "/" + session_id + "/sections",
    (response) =>
      response.data.data.map((a: any) =>
        sections.push({
          id: a.section,
        })
      )
  ))),
  await __temp,
  __restore()
);
  project_class = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v1/project_classes/" + course_id + "/" + session_id,
    (response) => new AdminProjectClass(response.data.data),
    () => undefined
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
}
if (project_class != undefined) {
  project_class.loadParms();
}
if (sections.length > 0) {
  selected_section.value = sections[0].id;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => updateStudents())),
  await __temp,
  __restore()
);
if (showPending.value) {
  (
  ([__temp,__restore] = _withAsyncContext(() => updatePendingStudents())),
  await __temp,
  __restore()
);
}
watch(selected_section, async () => {
  await updateStudents();
  students_trigger.value++;
});
watch(students_update, async () => {
  await updateStudents();
  if (showPending.value) {
    await updatePendingStudents();
  }
  students_trigger.value++;
});

return (_ctx: any,_cache: any) => {
  const _component_grades_manager = _resolveComponent("grades-manager")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_multiple_grades_manager = _resolveComponent("multiple-grades-manager")!
  const _component_course_description = _resolveComponent("course-description")!
  const _component_project_class_selector = _resolveComponent("project-class-selector")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal(_unref(store).state.event.event)))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonModal), {
      id: "grades_manager",
      "is-open": grades_open.value,
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (closeModal('grades')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_grades_manager, {
              title: _unref(grades_title),
              parameters: _unref(grades_parameters),
              grades: _unref(student_grades),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('grades'))),
              onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (manageEvent()))
            }, null, 8, ["title", "parameters", "grades"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      id: "multiple_grades_manager",
      "is-open": multiple_grades_open.value,
      onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (closeModal('multiple_grades')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_multiple_grades_manager, {
              parameters: multiple_grades_parameters,
              final_grades_indexes: final_grades_indexes,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (closeModal('multiple_grades'))),
              onSignal_event: _cache[5] || (_cache[5] = ($event: any) => (manageEvent()))
            })
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      "is-open": description_open.value,
      onDidDismiss: _cache[8] || (_cache[8] = ($event: any) => (closeModal('course_details')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_course_description, {
              title: _unref(description_title),
              course_id: _unref(description_course_id),
              learning_session_id: _unref(session_id),
              section: selected_section.value,
              onClose: _cache[7] || (_cache[7] = ($event: any) => (closeModal('course_details')))
            }, null, 8, ["title", "course_id", "learning_session_id", "section"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      id: "student_mover",
      "is-open": student_mover_open.value,
      onDidDismiss: _cache[11] || (_cache[11] = ($event: any) => (closeModal('student_mover')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_project_class_selector, {
              title: _unref(student_mover_data).title,
              student_id: _unref(student_mover_data).parameters.student_id,
              ordinary_class: _unref(student_mover_data).parameters.ordinary_class,
              learning_sessions: _unref(learning_sessions),
              project_class: _unref(project_class)?.toProjectClassSummary(),
              section: selected_section.value,
              subscriptions_manager: _unref(subscriptions_manager),
              onClose: _cache[9] || (_cache[9] = ($event: any) => (closeModal('student_mover'))),
              onSignal_event: _cache[10] || (_cache[10] = ($event: any) => (manageEvent()))
            }, null, 8, ["title", "student_id", "ordinary_class", "learning_sessions", "project_class", "section", "subscriptions_manager"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ionic_element, {
          element: 
            _unref(getCustomMessage)(
              'title',
              _unref(course) != undefined ? _unref(course)[`${_unref(language)}_title`] : '',
              'title',
              undefined,
              {
                label: {
                  title_font: true,
                },
              }
            )
          
        }, null, 8, ["element"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.slice(0, 2), (button) => {
        return (_openBlock(), _createBlock(_component_ionic_element, {
          key: button.id,
          element: button,
          onSignal_event: _cache[12] || (_cache[12] = ($event: any) => (setupModalAndOpen())),
          onExecute_link: _cache[13] || (_cache[13] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
        }, null, 8, ["element"]))
      }), 128)),
      (
          _unref(user).type == 'teacher' &&
          !_unref(associated_teacher) &&
          (_unref(learning_session_status) == _unref(LearningSessionStatus).CURRENT ||
            _unref(learning_session_status) == _unref(LearningSessionStatus).COMPLETED) &&
          !areAllFinals()
        )
        ? (_openBlock(), _createBlock(_component_ionic_element, {
            key: 0,
            element: buttons[2],
            onSignal_event: _cache[14] || (_cache[14] = ($event: any) => (manageEvent()))
          }, null, 8, ["element"]))
        : _createCommentVNode("", true),
      (
          _unref(user).type == 'admin' &&
          _unref(learning_session) != undefined &&
          _unref(project_class) != undefined &&
          (_unref(learning_session_status) == _unref(LearningSessionStatus).UPCOMING ||
            _unref(learning_session_status) == _unref(LearningSessionStatus).FUTURE)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(project_class).final_confirmation == undefined)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ionic_element, {
                    element: 
              _unref(getCustomMessage)(
                'project_class_status',
                _unref(getCurrentElement)('project_class_status') +
                  ':' +
                  (_unref(learning_session_status) != _unref(LearningSessionStatus).UPCOMING
                    ? ' ' + _unref(getCurrentElement)('not_confirmed')
                    : ''),
                'string',
                undefined,
                {
                  label: {
                    'ion-padding-end': true,
                    'ion-margin-start': {
                      general: true,
                      sm: false,
                    },
                  },
                }
              )
            
                  }, null, 8, ["element"]),
                  (_unref(learning_session_status) == _unref(LearningSessionStatus).UPCOMING)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        onClick: _cache[15] || (_cache[15] = 
              () => {
                _unref(store).state.event.event = 'confirmation';
                setupModalAndOpen();
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getCurrentElement)("confirm")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_component_ionic_element, {
                  key: 1,
                  element: 
              _unref(getCustomMessage)(
                'project_class_confirmation_date',
                _unref(getCurrentElement)('project_class_confirmation_date') +
                  ': ' +
                  _unref(toDateString)(_unref(project_class).final_confirmation),
                'string',
                undefined,
                {
                  label: {
                    'ion-margin-start': {
                      general: true,
                      sm: false,
                    },
                  },
                }
              )
            
                }, null, 8, ["element"]))
          ]))
        : _createCommentVNode("", true),
      (_unref(sections_use))
        ? (_openBlock(), _createBlock(_component_custom_select, {
            key: 2,
            selected_option: selected_section.value,
            "onUpdate:selected_option": _cache[16] || (_cache[16] = ($event: any) => ((selected_section).value = $event)),
            list: sections,
            label: _unref(getCurrentElement)('section') + ':',
            aria_label: _unref(getCurrentElement)('section'),
            placeholder: _unref(getCurrentElement)('section_choice'),
            classes: {
          label: {
            'ion-margin-start': {
              general: true,
              sm: false,
            },
          },
        }
          }, null, 8, ["selected_option", "label", "aria_label", "placeholder"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createBlock(_component_ionic_table, {
            key: students_trigger.value,
            emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('no_students')
              )
            ,
            data: table_data,
            first_row: first_row,
            sizes: _unref(column_sizes),
            onSignal_event: _cache[17] || (_cache[17] = ($event: any) => (setUpPendingAndOpen())),
            onExecute_link: _cache[18] || (_cache[18] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
          }, null, 8, ["emptiness_message", "sizes"]))
        ])
      ]),
      fallback: _withCtx(() => [
        _createVNode(_component_loading_component)
      ]),
      _: 1
    })),
    (_unref(showPending))
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ionic_element, {
                  element: 
                  _unref(getCustomMessage)(
                    'pending_students',
                    _unref(getCurrentElement)('pending_students'),
                    'title'
                  )
                
                }, null, 8, ["element"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createBlock(_component_ionic_table, {
                  key: students_trigger.value,
                  emptiness_message: 
                  _unref(getCustomMessage)(
                    'emptiness_message',
                    _unref(getCurrentElement)('no_students')
                  )
                ,
                  data: pending_table_data,
                  first_row: first_row,
                  sizes: _unref(column_sizes),
                  onSignal_event: _cache[19] || (_cache[19] = ($event: any) => (setUpPendingAndOpen(true))),
                  onExecute_link: _cache[20] || (_cache[20] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
                }, null, 8, ["emptiness_message", "sizes"]))
              ])
            ])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})